
<template>
  <b-container class="card-generator">
    <b-row class="buttons">
      <b-col>
        <b-button variant="primary" @click="generateNumbers">Crear Serie</b-button>
        <b-button variant="success" @click="saveSerie">Guardar Serie</b-button>
      </b-col>
    </b-row>
    <b-row no-gutters class="cards">
      <b-col lg="4" md="6" v-for="(card, cardId) in cards" :key="cardId">
        <div class="card-content">
          <span class="card-info">Cartón N.º {{parseInt(cardId) + 1}}</span>
          <table class="card-table">
            <tr v-for="(row, rowId) in card" :key="rowId">
              <td v-for="(number, numberId) in row" :key="numberId" v-bind:class="{empty: !number}">
                <span v-if="number">{{ number }}</span>
              </td>
            </tr>
          </table>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
const fb = require("../firebaseConfig.js");

export default {
  name: "serie-generator",
  data() {
    return {
      cards: [],
      columnPool: [
        [1, 1, 1, 2, 2, 2], // 1-9
        [1, 1, 2, 2, 2, 2], // 10-19
        [1, 1, 2, 2, 2, 2], // 20-29
        [1, 1, 2, 2, 2, 2], // 30-39
        [1, 1, 2, 2, 2, 2], // 40-49
        [1, 1, 2, 2, 2, 2], // 50-59
        [1, 1, 2, 2, 2, 2], // 60-69
        [1, 1, 2, 2, 2, 2], // 70-79
        [1, 2, 2, 2, 2, 2], // 80-90
      ]
    };
  },
  methods: {
    generateNumbers() {
      let serie = this.generateSpaces();
      let numbers = this.shuffle(Array.from({ length: 90 }, (v, k) => k + 1));
      numbers.forEach(number => {
        let isNumberSet = false;
        let columnIndex;
        if (number < 10) {
          columnIndex = 0;
        } else if (number < 20) {
          columnIndex = 1;
        } else if (number < 30) {
          columnIndex = 2;
        } else if (number < 40) {
          columnIndex = 3;
        } else if (number < 50) {
          columnIndex = 4;
        } else if (number < 60) {
          columnIndex = 5;
        } else if (number < 70) {
          columnIndex = 6;
        } else if (number < 80) {
          columnIndex = 7;
        } else if (number <= 90) {
          columnIndex = 8;
        }
        for (let cardIndex = 0; cardIndex < 6; cardIndex++) {
          for (let rowIndex = 0; rowIndex < 3; rowIndex++) {
            if (serie[cardIndex][rowIndex][columnIndex] === true) {
              serie[cardIndex][rowIndex][columnIndex] = number;
              isNumberSet = true;
            }
            if (isNumberSet) break;
          }
          if (isNumberSet) break;
        }
      });
      for (let cardIndex = 0; cardIndex < 6; cardIndex++) {
        serie[cardIndex] = this.sortCard(serie[cardIndex]);
      }
      console.log("Serie generated!");
      this.cards = serie;
    },
    generateSpaces() {
      let columns = this.generateColumns();
      let serie = this.getEmptyCards();
      // for each card
      for (let cardIndex = 0; cardIndex < 6; cardIndex++) {
        // for each column
        for (let columnIndex = 0; columnIndex < 9; columnIndex++) {
          // for each item (1 or 2)
          for (let item = 0; item < columns[columnIndex][cardIndex]; item++) {
            let penalty = [0,0,0];
            // For each row (cell)
            for (let rowIndex = 0; rowIndex < 3; rowIndex++) {
              // Is the cell already busy
              if (serie[cardIndex][rowIndex][columnIndex]) {
                penalty[rowIndex] = penalty[rowIndex] + 1000;
                continue;
              }
              // Is the row full (5 items) => +1000 penalty & continue
              if (serie[cardIndex][rowIndex].filter((a) => a === true).length === 5) {
                penalty[rowIndex] = penalty[rowIndex] + 1000;
                continue;
              }
              // Is column index 0 && the next 2 cells have items? => +100 penalty
              if (columnIndex === 0 && serie[cardIndex][rowIndex][columnIndex + 1] && serie[cardIndex][rowIndex][columnIndex + 2]) {
                penalty[rowIndex] = penalty[rowIndex] + 100;
              }
              // Is column index 1-6 && the next 2 cells have items? => +100 penalty
              if (columnIndex > 0 && columnIndex < 7 && serie[cardIndex][rowIndex][columnIndex + 1] && serie[cardIndex][rowIndex][columnIndex + 2]) {
                penalty[rowIndex] = penalty[rowIndex] + 100;
              }
              // Is column index 2-7 && the previous 2 cells have items? => +100 penalty
              if (columnIndex > 1 && columnIndex < 8 && serie[cardIndex][rowIndex][columnIndex - 1] && serie[cardIndex][rowIndex][columnIndex - 2]) {
                penalty[rowIndex] = penalty[rowIndex] + 100;
              }
              // Is column index 1-7 && the contiguous cells have items? => +100 penalty
              if (columnIndex > 0 && columnIndex < 8 && serie[cardIndex][rowIndex][columnIndex - 1] && serie[cardIndex][rowIndex][columnIndex + 1]) {
                penalty[rowIndex] = penalty[rowIndex] + 100;
              }
              // Is column index 8 && the previous 2 cells have items? => +100 penalty
              if (columnIndex === 8 && serie[cardIndex][rowIndex][columnIndex - 1] && serie[cardIndex][rowIndex][columnIndex - 2]) {
                penalty[rowIndex] = penalty[rowIndex] + 100;
              }
              // Does the previous cell have item? => +1 penalty
              if (columnIndex > 0 && serie[cardIndex][rowIndex][columnIndex - 1]) {
                penalty[rowIndex] = penalty[rowIndex] + 5;
              }
              // Does the next cell have item? => +1 penalty
              if (columnIndex < 8 && serie[cardIndex][rowIndex][columnIndex + 1]) {
                penalty[rowIndex] = penalty[rowIndex] + 5;
              }
              penalty[rowIndex] = penalty[rowIndex] + serie[cardIndex][rowIndex].filter((a) => a === true).length;
            }
            // Sort rows by score (asc) & Select first
            let selectedRowIndex = penalty.indexOf(Math.min(...penalty));
            serie[cardIndex][selectedRowIndex][columnIndex] = true;
          }
        }
      }

      for (let cardIndex = 0; cardIndex < 6; cardIndex++) {
        serie[cardIndex] = this.shuffleObject(serie[cardIndex]);
      }
      // console.log("Running tests");
      let testsPassed = true;
      for (let cardIndex = 0; cardIndex < 6; cardIndex++) {
        for (let rowIndex = 0; rowIndex < serie[cardIndex].length; rowIndex++) {
          let items = serie[cardIndex][rowIndex].filter((a) => a === true).length
          if ( items != 5) {
            console.error("Error on card", cardIndex, "row", rowIndex, ":", items);
            testsPassed = false;
          }
        }
      }
      let itemPerColumn = Array.from({ length: 9 }, () => 0);
      for (let columnIndex = 0; columnIndex < 9; columnIndex++) {
        for (let cardIndex = 0; cardIndex < 6; cardIndex++) {
          for (let rowIndex = 0; rowIndex < 3; rowIndex++) {
            if (serie[cardIndex][rowIndex][columnIndex]) {
              itemPerColumn[columnIndex]++
            }
          }
        }
      }
      for (let i = 0; i < itemPerColumn.length; i++) {
        if (i === 0 && itemPerColumn[i] != 9) {
          console.error("Error in first column:", itemPerColumn[0]);
          testsPassed = false;
        } else if (i > 0 && i < 8 && itemPerColumn[i] != 10) {
          console.error("Error in column", i, itemPerColumn[0]);
          testsPassed = false;
        } else if (i === 8 && itemPerColumn[i] != 11) {
          console.error("Error in last column", itemPerColumn[0]);
          testsPassed = false;
        }
      }
      if (testsPassed) console.info("Spaces generated!");
      return testsPassed ? serie : false;
    },
    generateColumns() {
      let columns;
      let testsPassed = false;
      let attempts = 0;
      while (!testsPassed) {
        attempts++;
        columns = Array.from({ length: 9 }, () => [0,0,0,0,0,0]);
        for (let columnIndex = 0; columnIndex < 9; columnIndex++) {
          let valueIndex;
          let computedValueIndexes = [];
          for (let cardIndex = 0; cardIndex < 6; cardIndex++) {
            if (columns[columnIndex][cardIndex]) {
              continue;
            }
            let selectedValue = false;
            if (this.countValueOnArrayIndex(1,columns,cardIndex) === 3) {
              // this.maxError(1, "card");
              selectedValue = 2;
              columns = this.setRestOfCardColumns(columns, cardIndex, columnIndex, 2);
            } else if (this.countValueOnArrayIndex(2,columns,cardIndex) === 6) {
              // this.maxError(2, "card");
              selectedValue = 1;
              columns = this.setRestOfCardColumns(columns, cardIndex, columnIndex, 1);
            } else if (columnIndex === 0 && columns[columnIndex].filter(a => a === 2).length === 3) {
              // this.maxError(2, "column");
              selectedValue = 1;
              columns = this.setRestOfColumn(columns, columnIndex, cardIndex, 1);
            } else if (columnIndex === 0 && columns[columnIndex].filter(a => a === 1).length === 3) {
              // this.maxError(1, "column");
              selectedValue = 2;
              columns = this.setRestOfColumn(columns, columnIndex, cardIndex, 2);
            } else if ( columnIndex > 0 && columnIndex < 8 && columns[columnIndex].filter(a => a === 2).length === 4) {
              // this.maxError(2, "column");
              selectedValue = 1;
              columns = this.setRestOfColumn(columns, columnIndex, cardIndex, 1);
            } else if (columnIndex > 0 && columnIndex < 9 && columns[columnIndex].filter(a => a === 1).length === 2) {
              // this.maxError(1, "column");
              selectedValue = 2;
              columns = this.setRestOfColumn(columns, columnIndex, cardIndex, 2);
            } else if (columnIndex === 9 && columns[columnIndex].filter(a => a === 2).length === 5) {
              // this.maxError(2, "column");
              selectedValue = 1;
              columns = this.setRestOfColumn(columns, columnIndex, cardIndex, 1);
            } else if (columnIndex === 9 && columns[columnIndex].filter(a => a === 1).length === 1) {
              // this.maxError(1, "column");
              selectedValue = 2;
              columns = this.setRestOfColumn(columns, columnIndex, cardIndex, 2);
            }
            let oneInLast = columns[8].indexOf(1);
            if (oneInLast != -1) {
              columns[8].fill(2);
              columns[8][oneInLast] = 1;
            }
            if (selectedValue) {
              valueIndex = this.getFirstValueNotInRange(selectedValue, this.columnPool[columnIndex], computedValueIndexes);
            } else {
              valueIndex = Math.floor(Math.random() * 6);
            }
            columns[columnIndex][cardIndex] = this.columnPool[columnIndex][valueIndex];
            computedValueIndexes.push(valueIndex);
          }
        }
        // console.info(columns);
        // console.log("Running tests");
        testsPassed = true;
        for (let columnIndex = 0; columnIndex < columns.length; columnIndex++) {
          if (columns[columnIndex].filter(Number).length != columns[columnIndex].length) {
            // console.error("Not all elements are numbers!");
            testsPassed = false;
          } else {
            let sum = columns[columnIndex].reduce((a, b) => a + b, 0);
            if (columnIndex === 0 && sum != 9) {
              // console.error("Error in first column");
              testsPassed = false;
            } else if (columnIndex > 0 && columnIndex < 8 && sum != 10) {
              // console.error("Error in column", columnIndex);
              testsPassed = false;
            } else if (columnIndex === 8 && sum != 11) {
              // console.error("Error in last column");
              testsPassed = false;
            }
          }
        }
        for (let cardIndex = 0; cardIndex < 6; cardIndex++) {
          let count = 0;
          for (let columnIndex = 0; columnIndex < columns.length; columnIndex++) {
            count = count + columns[columnIndex][cardIndex];
          }
          if (count != 15) {
            // console.error("Error counting numbers in card", cardIndex);
            testsPassed = false;
          }
        }
      }
      console.info("Columns generated after", attempts, "attempts");
      return columns;
    },
    saveSerie() {
      let number = 1;
      fb.ticketsCollection.orderBy("serie", "desc").limit(1).get().then(querySnapshot => {
        const documents = querySnapshot.docs.map(doc => doc.data());
        if (documents.length != 0) {
          number = documents[0].serie + 1;
        }
        let batch = fb.db.batch();
        for (let cardIndex = 0; cardIndex < 6; cardIndex++) {
          let ticketRef = fb.ticketsCollection.doc()
          batch.set(ticketRef, {
            id: ticketRef.id,
            number: cardIndex + 1,
            numbers: this.cards[cardIndex],
            serie: number,
          });
        }
        batch.commit()
        .then(() => {
          console.log('Tickets saved to DB');
        })
        .catch(err => {
          console.error(err);
        });
      })
    },
    sortCard(card) {
      console.log("SORTING CARD")
      let columns = Array.from({ length: 9}, () => [])
      // Get columns
      for (let i = 0; i < 3; i++) {
        for (let x = 0; x < 9; x++) {
          if (card[i][x]) {
            columns[x].push(card[i][x]);
          }
        }
      }
      // Sort columns
      for (let i = 0; i < columns.length; i++) {
        columns[i].sort();
      }
      // Apply columns
      for (let i = 0; i < 3; i++) {
        for (let x = 0; x < 9; x++) {
          if (card[i][x]) {
            card[i][x] = columns[x].shift();
          }
        }
      }
      return card;
    },
    setRestOfColumn(columns, columnIndex, cardIndex, number) {
      let generatedColumns = columns;
      for (let i = cardIndex; i < 6; i++) {
        generatedColumns[columnIndex][i] = number;
      }
      return generatedColumns;
    },
    setRestOfCardColumns(columns, cardIndex, columnIndex, number) {
      let generatedColumns = columns;
      for (let i = columnIndex; i < 9; i++) {
        generatedColumns[i][cardIndex] = number;
      }
      return generatedColumns;
    },
    maxError(number, item) {
      console.error("Max number of", number, "for", item)
    },
    countValueOnArrayIndex(value, array, index) {
      let count = 0;
      for (let i = 0; i < array.length; i++) {
        if (array[i][index] === value) {
          count++;
        }
      }
      return count;
    },
    getFirstValueNotInRange(value, array, range) {
      for (let index = 0; index < array.length; index++) {
        if (array[index] === value && range.indexOf(index) == -1) {
          return index;
        }
      }
    },
    countCardsWithFullColumn(columnIndex) {
      let count = 0;
      for (let cardIndex = 0; cardIndex < 6; cardIndex++) {
        let items = this.countItemsInColumn(cardIndex, columnIndex);
        if (items === 2) {
          count++;
        }
      }
      return count;
    },
    getCardsWithLessItemsInColumn(columnIndex) {
      let cards = [];
      let min = 3;
      let items;
      for (let index = 0; index < 6; index++) {
        items = this.countItemsInColumn(index, columnIndex);
        if (items === min) {
          cards.push(index);
        } else if (items < min) {
          cards = [index];
          min = items;
        }
      }
      console.log("Cards with less items in column", columnIndex, cards);
      return cards;
    },
    countColumnsWithNumber(cardIndex, number) {
      let items = 0;
      for (let columnIndex = 0; columnIndex < 9; columnIndex++) {
        if (this.countItemsInColumn(cardIndex, columnIndex) === number) {
          items++;
        }
      }
      return items;
    },
    countItemsInColumn(cardIndex, columnIndex) {
      let items = 0;
      for (let index = 0; index < 3; index++) {
        if (this.cards[cardIndex][index][columnIndex]) {
          items++;
        }
      }
      return items;
    },
    clearNumbers() {
      this.cards = this.getEmptyCards();
    },
    shuffle(a) {
      for (let i = a.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [a[i], a[j]] = [a[j], a[i]];
      }
      return a;
    },
    shuffleObject(o) {
      let finalObj = {};
      let initialKeys = Object.keys(o);
      this.shuffle(initialKeys);
      for (let k = 0; k < initialKeys.length; k++) {
        finalObj[k] = o[initialKeys[k]];
      }
      return finalObj;
    },
    getEmptyCards() {
      let serie = {}
      for (let cardIndex = 0; cardIndex < 6; cardIndex++) {
        for (let rowIndex = 0; rowIndex < 3; rowIndex++) {
          serie[cardIndex] = serie[cardIndex] ? serie[cardIndex] : {};
          serie[cardIndex][rowIndex] = Array.from({ length: 9 }, () => false);
        }
      }
      return serie
    }
  }
};
</script>

<style lang="scss" scoped>
.card-generator {
  text-align: center;
}
.cards {
  margin-top: 20px;
}
</style>